<template>
  <div class="modal-content">
    <div class="modal-header">
      <h4 class="modal-title">{{ _('Booking') }}</h4>
    </div>
    <div class="modal-body">
      <div class="row">
        <div class="col-md-12" v-if="channexToken && channexBooking && channexProperty">
          <iframe frameBorder="0" width="100%" height="600px" :src="channexToken.server + '/auth/exchange?oauth_session_key=' + channexToken.token + '&app_mode=headless&allow_notifications_edit=true&redirect_to=/bookings/' + channexBooking + '&property_id=' + channexProperty"></iframe>
        </div>
      </div>
    </div>
    <div class="modal-footer">
      <button class="btn btn-default" v-on:click="hideModal"><i class="fa fa-fw fa-close"></i> {{ _('Close') }}</button>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import errors from '~/lib/errors'
import { mapGetters } from 'vuex'

export default {
  mixins: [errors],
  props: ['channexBooking', 'channexProperty'],
  data () {
    return {
      channexToken: false,
    }
  },
  computed: {
    ...mapGetters(['shopId', 'baseDomain', 'apiKey'])
  },
  methods: {
    loadChannexToken () {
      return new Promise(async (resolve, reject) => {
        let response
        try {
          response = await axios.post(this.baseDomain + this.shopId + '/channextokens.json?apikey=' + this.apiKey)
        } catch(e) {
          if (e && e.code !== 'ERR_CANCELED') {
            if (e && e.response && e.response.status === 404) {
              // Channex token has been deleted, fail silently
            } else {
              this.showError(e)
            }
          }
          reject(e)
          return
        }
        this.channexToken = response.data
        resolve(response.data)
      })
    },
    hideModal () {
      this.$emit('close')
    },
  },
  mounted () {
    this.loadChannexToken()
  }
}
</script>